import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { pushModal } from 'loot-core/client/actions';

import { useNavigate } from '../../hooks/useNavigate';

export function BillingPaymentMethodChangedModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isPostChangeMethod = searchParams.get('post-change-method');
    const productId = searchParams.get('productId');
    const selectedBillingInterval = searchParams.get('billingInterval');
    if (isPostChangeMethod !== '1' || (productId && selectedBillingInterval)) {
      return;
    }

    dispatch(
      pushModal('confirm-generic', {
        title: 'Payment method updated',
        text: 'The payment method for your subscription plan has been successfully updated.',
        hideCancelButton: true,
        confirmBtnText: 'Ok',
        onConfirm: () => {
          navigate('/billing');
        },
      }),
    );
  }, []);

  return <></>;
}
